/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "../adminShared";
import { PlacementEditor } from "../PlacementEditor";
import { VotingColumnEditor } from "../VotingColumnEditor";

export const MediaSection = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, bgVideoBlur, setBgVideoBlur, bgVideoBrightness, setBgVideoBrightness, bgVideoOpacity, setBgVideoOpacity, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, rowBgEvenTranslucent, setRowBgEvenTranslucent, rowBgOddTranslucent, setRowBgOddTranslucent, rowBadgeTranslucent, setRowBadgeTranslucent, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    soundWinnerUrl, setSoundWinnerUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, positionBadgeTranslucent, setPositionBadgeTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, mysteryHiddenPoints, setMysteryHiddenPoints, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    fontTitleItalic, setFontTitleItalic, fontSubtitleItalic, setFontSubtitleItalic, fontCountryItalic, setFontCountryItalic,
    fontPointsItalic, setFontPointsItalic, fontVotingItalic, setFontVotingItalic, fontVotingSecondaryItalic, setFontVotingSecondaryItalic,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ShowConfetti, setOverlay12ShowConfetti, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  // Convert a hex/rgba color string into a #rrggbb value usable by <input type="color">.
  const toPickerHex = (c) => {
    if (!c || typeof c !== 'string') return "#000000";
    if (c.startsWith('#')) return c.slice(0, 7).padEnd(7, '0');
    const m = c.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map((s) => parseInt(s.trim(), 10));
      const h = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n)).toString(16).padStart(2, '0');
      return `#${h(parts[0])}${h(parts[1])}${h(parts[2])}`;
    }
    return "#000000";
  };
  return (
    <>
                {/* Vídeo de Fondo */}
                <div>
                  <Label htmlFor="video-url" className="text-zinc-300 mb-2 block font-semibold">Vídeo de Fondo</Label>
                  <p className="text-zinc-500 text-sm mb-2">URL del vídeo MP4 o sube archivo desde tu ordenador</p>
                  <Input
                    id="video-url"
                    data-testid="input-background-video"
                    value={backgroundVideo}
                    onChange={(e) => setBackgroundVideo(e.target.value)}
                    className="bg-zinc-800 border-zinc-700 text-white mb-2"
                    placeholder="URL o sube archivo"
                  />
                  
                  <div>
                    <input
                      type="file"
                      id="video-file"
                      accept="video/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) await handleFileUpload(file, 'video');
                      }}
                    />
                    <Button
                      type="button"
                      onClick={() => document.getElementById('video-file').click()}
                      variant="outline"
                      className="w-full bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                    >
                      <Upload className="w-4 h-4 mr-2" />
                      Subir Vídeo desde Archivo
                    </Button>
                  </div>
                  
                  {/* Video Preview */}
                  {backgroundVideo && (
                    <div className="mt-3 p-2 bg-zinc-900 rounded-lg">
                      <p className="text-zinc-400 text-sm mb-2">Vista previa del vídeo:</p>
                      <video 
                        src={resolveUrl(backgroundVideo)}
                        className="w-full max-h-32 rounded object-cover"
                        muted
                        loop
                        autoPlay
                        playsInline
                        onError={(e) => e.target.style.display = 'none'}
                      />
                    </div>
                  )}

                  {/* Ajustes visuales del fondo (vídeo o imagen) */}
                  <div className="mt-4 p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                    <Label className="text-zinc-300 mb-1 block font-semibold">Ajustes del Fondo</Label>
                    <p className="text-zinc-500 text-xs mb-4">Controla cómo se ve el vídeo (o la imagen) de fondo en el Visualizer</p>
                    <div className="space-y-4">
                      <div>
                        <Label className="text-zinc-400 text-sm mb-1 block">Brillo: {bgVideoBrightness}%</Label>
                        <input
                          type="range" min="0" max="200" value={bgVideoBrightness}
                          onChange={(e) => setBgVideoBrightness(Number(e.target.value))}
                          className="w-full accent-pink-500"
                          data-testid="slider-bg-brightness"
                        />
                      </div>
                      <div>
                        <Label className="text-zinc-400 text-sm mb-1 block">Difuminado (blur): {bgVideoBlur}px</Label>
                        <input
                          type="range" min="0" max="40" value={bgVideoBlur}
                          onChange={(e) => setBgVideoBlur(Number(e.target.value))}
                          className="w-full accent-cyan-500"
                          data-testid="slider-bg-blur"
                        />
                      </div>
                      <div>
                        <Label className="text-zinc-400 text-sm mb-1 block">Opacidad: {bgVideoOpacity}%</Label>
                        <input
                          type="range" min="0" max="100" value={bgVideoOpacity}
                          onChange={(e) => setBgVideoOpacity(Number(e.target.value))}
                          className="w-full accent-purple-500"
                          data-testid="slider-bg-opacity"
                        />
                      </div>
                      {/* Live preview of the combined effect */}
                      <div>
                        <p className="text-zinc-400 text-xs mb-1">Vista previa del efecto:</p>
                        <div className="relative h-24 rounded-lg overflow-hidden border border-zinc-700 bg-[#09090B]">
                          {backgroundVideo ? (
                            <video
                              src={resolveUrl(backgroundVideo)}
                              className="absolute inset-0 w-full h-full object-cover"
                              style={{ opacity: bgVideoOpacity / 100, filter: `blur(${bgVideoBlur}px) brightness(${bgVideoBrightness}%)` }}
                              muted loop autoPlay playsInline
                            />
                          ) : (
                            <div
                              className="absolute inset-0"
                              style={{
                                opacity: bgVideoOpacity / 100,
                                backgroundImage: "url('https://images.unsplash.com/photo-1721623777765-1381ba32859c?crop=entropy&cs=srgb&fm=jpg&q=85')",
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                filter: `blur(${bgVideoBlur}px) brightness(${bgVideoBrightness}%)`
                              }}
                            />
                          )}
                          <div className="relative z-10 h-full flex items-center justify-center">
                            <span className="text-white text-sm font-semibold drop-shadow-lg">Texto de ejemplo</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sonido para los 12 Puntos */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-2 block font-semibold flex items-center gap-2">
                    <Volume2 className="w-4 h-4" />
                    Sonido al Revelar los 12 Puntos
                  </Label>
                  <p className="text-zinc-500 text-sm mb-3">Este sonido se reproducirá en el Visualizer cuando se sumen los votos y se revelen los 12 puntos</p>
                  
                  <Input
                    value={sound12PointsUrl}
                    onChange={(e) => setSound12PointsUrl(e.target.value)}
                    className="bg-zinc-800 border-zinc-700 text-white mb-2"
                    placeholder="URL del archivo de audio o sube archivo"
                    data-testid="input-sound-12-points"
                  />
                  
                  <div>
                    <input
                      type="file"
                      id="sound-12-file"
                      accept="audio/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) await handleFileUpload(file, 'sound12');
                      }}
                    />
                    <Button
                      type="button"
                      onClick={() => document.getElementById('sound-12-file').click()}
                      variant="outline"
                      className="w-full bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                    >
                      <Upload className="w-4 h-4 mr-2" />
                      Subir Sonido desde Archivo
                    </Button>
                  </div>
                  
                  {/* Audio Preview */}
                  {sound12PointsUrl && (
                    <div className="mt-3 flex items-center gap-3 p-2 bg-zinc-900 rounded-lg">
                      <audio 
                        src={resolveUrl(sound12PointsUrl)}
                        controls
                        className="h-8 flex-1"
                      />
                      <Button
                        type="button"
                        onClick={() => setSound12PointsUrl("")}
                        variant="outline"
                        size="icon"
                        className="bg-red-900/30 border-red-800 hover:bg-red-900/50 text-red-400"
                        title="Quitar sonido"
                      >
                        <X className="w-4 h-4" />
                      </Button>
                    </div>
                  )}
                </div>

                {/* Sonido para el Ganador */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-2 block font-semibold flex items-center gap-2">
                    <Volume2 className="w-4 h-4" />
                    Sonido al Mostrar el Ganador
                  </Label>
                  <p className="text-zinc-500 text-sm mb-3">Este sonido se reproducirá en el Visualizer al mostrar el overlay del ganador</p>

                  <Input
                    value={soundWinnerUrl}
                    onChange={(e) => setSoundWinnerUrl(e.target.value)}
                    className="bg-zinc-800 border-zinc-700 text-white mb-2"
                    placeholder="URL del archivo de audio o sube archivo"
                    data-testid="input-sound-winner"
                  />

                  <div>
                    <input
                      type="file"
                      id="sound-winner-file"
                      accept="audio/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) await handleFileUpload(file, 'soundWinner');
                      }}
                    />
                    <Button
                      type="button"
                      onClick={() => document.getElementById('sound-winner-file').click()}
                      variant="outline"
                      className="w-full bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                      data-testid="btn-upload-sound-winner"
                    >
                      <Upload className="w-4 h-4 mr-2" />
                      Subir Sonido desde Archivo
                    </Button>
                  </div>

                  {/* Audio Preview */}
                  {soundWinnerUrl && (
                    <div className="mt-3 flex items-center gap-3 p-2 bg-zinc-900 rounded-lg">
                      <audio
                        src={resolveUrl(soundWinnerUrl)}
                        controls
                        className="h-8 flex-1"
                      />
                      <Button
                        type="button"
                        onClick={() => setSoundWinnerUrl("")}
                        variant="outline"
                        size="icon"
                        className="bg-red-900/30 border-red-800 hover:bg-red-900/50 text-red-400"
                        title="Quitar sonido"
                      >
                        <X className="w-4 h-4" />
                      </Button>
                    </div>
                  )}
                </div>

                {/* Efecto de Confetti */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Sparkles className="w-4 h-4 text-yellow-400" />
                      <Label className="text-zinc-300 font-semibold">Efecto de Confetti</Label>
                    </div>
                    <button
                      type="button"
                      onClick={() => setConfettiEnabled(!confettiEnabled)}
                      className={`relative w-14 h-7 rounded-full transition-colors ${
                        confettiEnabled ? 'bg-pink-600' : 'bg-zinc-700'
                      }`}
                      data-testid="toggle-confetti"
                    >
                      <span 
                        className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform ${
                          confettiEnabled ? 'translate-x-8' : 'translate-x-1'
                        }`}
                      />
                    </button>
                  </div>
                  <p className="text-zinc-500 text-sm mb-4">
                    {confettiEnabled 
                      ? "Se mostrará confetti en el Visualizer cuando se revelen los 12 puntos" 
                      : "El efecto de confetti está desactivado"
                    }
                  </p>
                  
                  {/* Color pickers for confetti */}
                  {confettiEnabled && (
                    <div className="space-y-3">
                      <Label className="text-zinc-400 text-sm">Colores del Confetti</Label>
                      <div className="flex flex-wrap gap-3">
                        {confettiColors.map((color, index) => (
                          <div key={`confetti-${index}-${color}`} className="flex items-center gap-2">
                            <input
                              type="color"
                              value={color}
                              onChange={(e) => {
                                const newColors = [...confettiColors];
                                newColors[index] = e.target.value;
                                setConfettiColors(newColors);
                              }}
                              className="w-10 h-10 rounded cursor-pointer border-2 border-zinc-600 hover:border-zinc-500"
                              title={`Color ${index + 1}`}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                if (confettiColors.length > 2) {
                                  setConfettiColors(confettiColors.filter((_, i) => i !== index));
                                }
                              }}
                              className="text-zinc-500 hover:text-red-400 transition-colors"
                              title="Quitar color"
                              disabled={confettiColors.length <= 2}
                            >
                              <X className="w-4 h-4" />
                            </button>
                          </div>
                        ))}
                        {confettiColors.length < 8 && (
                          <button
                            type="button"
                            onClick={() => setConfettiColors([...confettiColors, "#FFFFFF"])}
                            className="w-10 h-10 rounded border-2 border-dashed border-zinc-600 hover:border-pink-500 flex items-center justify-center text-zinc-500 hover:text-pink-500 transition-colors"
                            title="Añadir color"
                          >
                            <Plus className="w-5 h-5" />
                          </button>
                        )}
                      </div>
                      <p className="text-zinc-600 text-xs">Mínimo 2 colores, máximo 8. Haz clic en cada color para cambiarlo.</p>
                      
                      {/* Preview of confetti colors */}
                      <div className="flex items-center gap-2 mt-2">
                        <span className="text-zinc-500 text-sm">Vista previa:</span>
                        <div className="flex gap-1">
                          {confettiColors.map((color, i) => (
                            <div 
                              key={`confetti-preview-${i}-${color}`}
                              className="w-4 h-4 rounded-full shadow-lg"
                              style={{ backgroundColor: color }}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
    </>
  );
};
